import { createContext, EActiveView, IState } from '@cian/authentication-widget';
import { IHttpApi } from '@cian/http-api';
import { IConfig } from '@cian/config/shared';
import { ILogger } from '@cian/logger';
import { uaToDeviceType } from '@cian/ui-kit';

import { IExperiment } from '../../../../shared/types/experiments';
import { isNextAgreementFlow } from './isNextAgreementFlow';

interface IDependencies {
  httpApi: IHttpApi;
  config: IConfig;
  logger: ILogger;
}

interface IParameters {
  subdomain: string;
  experiments: IExperiment[];
}

export function getAuthenticationSettings(dependencies: IDependencies, { subdomain, experiments }: IParameters) {
  const { httpApi, config, logger } = dependencies;
  const isAdaptive = config.get<boolean>('isAdaptive');
  const deviceType = isAdaptive ? uaToDeviceType(window.navigator.userAgent) : 'desktop';
  const initialView = deviceType === 'phone' ? EActiveView.PhoneAuth : EActiveView.AuthenticationRegistration;

  const preloadedState: Partial<IState> = {
    view: {
      active: initialView,
    },
    isNextAgreementFlow: isNextAgreementFlow(dependencies, experiments),
  };

  const context = createContext(
    {
      httpApi,
      logger,
      subdomain,
    },
    preloadedState,
  );

  return {
    context,
    initialView,
  };
}
